// ICS calendar file generation

export function generateICS(params: {
  title: string
  description?: string
  location?: string
  startAt: Date
  durationMinutes: number
}): string {
  const { title, description = '', location = '', startAt, durationMinutes } = params

  function fmt(d: Date): string {
    const p = (n: number) => String(n).padStart(2, '0')
    return (
      `${d.getUTCFullYear()}${p(d.getUTCMonth() + 1)}${p(d.getUTCDate())}` +
      `T${p(d.getUTCHours())}${p(d.getUTCMinutes())}00Z`
    )
  }

  const endAt = new Date(startAt.getTime() + durationMinutes * 60_000)
  const now = new Date()

  const lines = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//MeuDriver//MeuDriver//PT',
    'BEGIN:VEVENT',
    `UID:${startAt.getTime()}-${Math.random().toString(36).slice(2)}@meudriver.app`,
    `DTSTAMP:${fmt(now)}`,
    `DTSTART:${fmt(startAt)}`,
    `DTEND:${fmt(endAt)}`,
    `SUMMARY:${title}`,
    ...(description ? [`DESCRIPTION:${description.replace(/[\r\n]+/g, '\\n')}`] : []),
    ...(location ? [`LOCATION:${location}`] : []),
    'END:VEVENT',
    'END:VCALENDAR',
  ]

  return lines.join('\r\n')
}

export function downloadICS(filename: string, content: string): void {
  const blob = new Blob([content], { type: 'text/calendar;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}
